import { defineComponent as I, useSlots as T, ref as k, onMounted as U, onUpdated as N, computed as A, openBlock as d, createElementBlock as u, normalizeClass as B, createElementVNode as f, unref as o, renderSlot as n, createCommentVNode as s, createBlock as y, withCtx as b, Fragment as F, renderList as P, createTextVNode as H, toDisplayString as L, createVNode as p } from "vue";
import K from "./ghl-ui.es168.js";
import V from "./ghl-ui.es169.js";
import "./ghl-ui.es22.js";
import "./ghl-ui.es23.js";
import "./ghl-ui.es36.js";
import "./ghl-ui.es6.js";
import "./ghl-ui.es42.js";
import q from "./ghl-ui.es170.js";
import "./ghl-ui.es171.js";
import D from "./ghl-ui.es66.js";
import E from "./ghl-ui.es65.js";
import R from "./ghl-ui.es70.js";
import O from "./ghl-ui.es146.js";
import X from "./ghl-ui.es172.js";
import j from "./ghl-ui.es73.js";
const G = { class: "ghl-table-custom-header" }, M = { class: "filter-bar--left" }, J = { class: "filter-bar--right" }, Q = {
  key: 1,
  class: "hl-breadcrumb"
}, W = { class: "ghl-table-container" }, Y = { key: 0 }, Z = {
  key: 0,
  class: "ghl-table-footer"
}, _ = { class: "ghl-table-footer-left" }, ee = { class: "ghl-table-footer-right" }, te = {
  key: 1,
  class: "pagination"
}, ae = I({
  name: "UITable",
  inheritAttrs: !1
}), le = I({
  ...ae,
  props: {
    id: {
      type: String,
      required: !0
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number
    },
    pageCount: {
      type: Number
    },
    tabs: {
      type: Array,
      default: () => []
    },
    enableTextSearch: {
      type: Boolean,
      default: !0
    },
    enableFilter: {
      type: Boolean,
      default: !0
    },
    filterCollapseItems: {
      type: Array,
      default: () => []
    },
    filterOptions: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: !1
    },
    defaultTab: {
      type: String,
      default: ""
    },
    rowKey: Function,
    checkedRowKeys: Array,
    searchInputPlaceholder: {
      type: String,
      default: void 0
    },
    defaultExpandAll: {
      type: Boolean,
      default: !1
    },
    searchText: {
      type: String,
      default: ""
    },
    transparent: {
      type: Boolean,
      default: !1
    },
    showSizePicker: {
      type: Boolean,
      default: !1
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    },
    pageSize: {
      type: Number,
      default: void 0
    },
    pageSlot: {
      type: Number,
      default: 9
    },
    dragSort: {
      type: Boolean,
      default: !1
    },
    dragIconClass: {
      type: String,
      required: !1
    },
    scrollX: {
      type: [Number, void 0],
      required: !1,
      default: void 0
    },
    scrollbarProps: {
      type: Object,
      required: !1,
      default: void 0
    },
    virtualScroll: {
      type: Boolean,
      required: !1,
      default: !1
    },
    flexHeight: {
      type: Boolean,
      required: !1,
      default: !1
    },
    maxHeight: {
      type: [Number, String],
      default: void 0
    },
    minHeight: {
      type: Number,
      default: void 0
    },
    tableLayout: {
      type: String,
      default: "auto"
    },
    rowClassName: {
      type: String,
      default: void 0
    },
    rowProps: {
      type: Function,
      default: void 0
    },
    hideBorder: {
      type: Boolean,
      default: !1
    },
    hideCellBorder: {
      type: Boolean,
      default: !1
    },
    hideHeadingBorder: {
      type: Boolean,
      default: !1
    },
    cascade: {
      type: Boolean,
      default: !0
    },
    indent: {
      type: Number,
      default: 16
    },
    remote: {
      type: Boolean,
      default: !1
    },
    striped: {
      type: Boolean,
      default: !1
    },
    onLoad: {
      type: Function,
      default: void 0
    },
    onScroll: {
      type: Function,
      default: void 0
    },
    hideFooter: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:page",
    "update:page-size",
    "update:searchText",
    "update:filter",
    "update:checkedRowKeys",
    "update:sorter",
    "update:defaultTab",
    "update:dragSort"
  ],
  setup(e, { emit: z }) {
    const t = e, m = z;
    function w(a) {
      m("update:defaultTab", a.key);
    }
    function $(a) {
      m("update:searchText", a);
    }
    const i = T(), v = k(!1), c = k([]), C = (a) => {
      if (t.dragSort) {
        const {
          data: { oldIndex: r, newIndex: g }
        } = a, h = V({
          array: c.value.length ? c.value : t.data,
          oldIndex: r,
          newIndex: g
        });
        m("update:dragSort", {
          updatedList: h,
          sorted: c.value.length ? c.value[r] : t.data[r],
          oldIndex: r,
          newIndex: g
        }), c.value = h;
      }
    }, S = () => {
      if ((t == null ? void 0 : t.dragSort) === !0 && (t != null && t.data) && !v.value) {
        const a = q(t == null ? void 0 : t.dragIconClass);
        a ? (a.on("sortable:stop", C), v.value = !0) : console.warn(
          `ghl-ui:: Dragging is not initialized for table - ${t.id}`
        );
      }
    };
    U(() => {
      S();
    }), N(() => S());
    const x = A(() => (t == null ? void 0 : t.tabs.length) || (t == null ? void 0 : t.enableTextSearch) || i["filter-right"] || i["filter-left"] || i["filter-left-start"] || i["filter-left-end"] || i["filter-right-start"] || i["filter-right-end"] || (t == null ? void 0 : t.filterCollapseItems.length));
    return (a, r) => {
      var g, h;
      return d(), u("div", {
        class: B(["table-container", {
          "ghl-transparent-heading": e.transparent,
          "hide-border": e.hideBorder,
          "hide-cell-border": e.hideCellBorder,
          "hide-header-border": e.hideHeadingBorder,
          "hide-footer": e.hideFooter
        }])
      }, [
        f("div", G, [
          x.value ? (d(), u("div", {
            key: 0,
            class: B(o(i).breadcrumb ? "filter-bar-breadcrumb" : "filter-bar")
          }, [
            f("div", M, [
              n(a.$slots, "filter-left"),
              (g = o(i)) != null && g["filter-left"] ? s("", !0) : n(a.$slots, "filter-left-start", { key: 0 }),
              e.tabs.length ? (d(), y(o(D), { key: 1 }, {
                default: b(() => [
                  (d(!0), u(F, null, P(e.tabs, (l) => (d(), y(o(E), {
                    size: "large",
                    key: l.key,
                    onClick: (re) => w(l),
                    id: `hl-table-${e.id}-filter-tab-${l.key}`,
                    active: e.defaultTab === l.key
                  }, {
                    default: b(() => [
                      H(L(l == null ? void 0 : l.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "id", "active"]))), 128))
                ]),
                _: 1
              })) : s("", !0),
              n(a.$slots, "filter-left-end")
            ]),
            f("div", J, [
              n(a.$slots, "filter-right"),
              (h = o(i)) != null && h["filter-right"] ? s("", !0) : n(a.$slots, "filter-right-start", { key: 0 }),
              e.enableTextSearch ? (d(), y(o(R), {
                key: 1,
                class: "filter-search",
                modelValue: e.searchText,
                "onUpdate:modelValue": $,
                clearable: "",
                size: "large",
                placeholder: e.searchInputPlaceholder,
                id: `hl-table-${e.id}-filter-text-search`
              }, {
                prefix: b(() => [
                  p(o(K), { class: "w-4 h-4" })
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder", "id"])) : s("", !0),
              e.filterCollapseItems.length ? (d(), y(o(O), {
                key: 2,
                options: e.filterOptions,
                collapseItems: e.filterCollapseItems,
                id: e.id,
                "onUpdate:filter": r[0] || (r[0] = (l) => m("update:filter", l))
              }, null, 8, ["options", "collapseItems", "id"])) : s("", !0),
              n(a.$slots, "filter-right-end")
            ])
          ], 2)) : s("", !0),
          o(i).breadcrumb ? (d(), u("div", Q, [
            n(a.$slots, "breadcrumb")
          ])) : s("", !0)
        ]),
        f("div", W, [
          p(o(X), {
            "default-expand-all": e.defaultExpandAll,
            "onUpdate:sorter": r[1] || (r[1] = (l) => a.$emit("update:sorter", l)),
            "checked-row-keys": e.checkedRowKeys,
            "onUpdate:checkedRowKeys": r[2] || (r[2] = (l) => a.$emit("update:checkedRowKeys", l)),
            "row-key": e.rowKey,
            columns: t.columns,
            data: e.data,
            pagination: !1,
            bordered: !1,
            loading: e.loading,
            "scroll-x": e.scrollX,
            "scrollbar-props": e.scrollbarProps,
            "virtual-scroll": e.virtualScroll,
            "flex-height": e.flexHeight,
            "max-height": e.maxHeight,
            "min-height": e.minHeight,
            "table-layout": e.tableLayout,
            "row-class-name": e.rowClassName,
            "row-props": e.rowProps,
            cascade: e.cascade,
            indent: e.indent,
            remote: e.remote,
            striped: e.striped,
            onLoad: e.onLoad,
            onScroll: e.onScroll
          }, {
            empty: b(() => [
              n(a.$slots, "empty")
            ]),
            _: 3
          }, 8, ["default-expand-all", "checked-row-keys", "row-key", "columns", "data", "loading", "scroll-x", "scrollbar-props", "virtual-scroll", "flex-height", "max-height", "min-height", "table-layout", "row-class-name", "row-props", "cascade", "indent", "remote", "striped", "onLoad", "onScroll"]),
          e.hideFooter ? s("", !0) : (d(), u("div", Y, [
            e.data.length ? (d(), u("div", Z, [
              f("div", _, [
                o(i)["footer-left"] ? n(a.$slots, "footer-left", { key: 0 }) : s("", !0)
              ]),
              f("div", ee, [
                o(i).pagination ? n(a.$slots, "pagination", { key: 0 }) : (d(), u("div", te, [
                  p(o(j), {
                    "show-size-picker": e.showSizePicker,
                    "page-sizes": e.pageSizes,
                    "page-size": e.pageSize,
                    "page-count": e.pageCount,
                    "onUpdate:page": r[3] || (r[3] = (l) => a.$emit("update:page", l)),
                    "onUpdate:pageSize": r[4] || (r[4] = (l) => a.$emit("update:page-size", l)),
                    page: e.page,
                    id: e.id,
                    "page-slot": e.pageSlot
                  }, null, 8, ["show-size-picker", "page-sizes", "page-size", "page-count", "page", "id", "page-slot"])
                ]))
              ])
            ])) : s("", !0)
          ]))
        ])
      ], 2);
    };
  }
}), ke = le;
export {
  ke as default
};
